export default __webpack_public_path__ + "static/media/show-earphone-1.a4c02bcb.webp";